import { Pipe, PipeTransform, inject } from '@angular/core'
import { SharedConstantService } from '../services'
import { ConstantLite } from '@agroone/entities'

@Pipe({
  name: 'translateConstant',
})
export class TranslateConstantPipe implements PipeTransform {
  private constantService = inject(SharedConstantService)

  transform(code: string | null | undefined, constants: ConstantLite[]): string {
    return this.constantService.translate(code, constants)
  }
}
